module.exports = __webpack_public_path__ + "media/images/twitter-290b201d9c134dc965c700af03e89218.gif";